import { Link } from "react-router-dom"
import { formatDate } from "../services/helpers"
export function NoteTile({note}){
	return <div className="note-tile">
		<div >
			<b className={`note-type ${note.tags}`}> {note.tags}</b>
			<p>Last Updated: {formatDate(note.date_created)}</p>
            <p><b>Added By</b> {note.buddy_name}</p>
		</div>
            <p className="comments"> {note.note_text}</p>
	</div>
}